import Navbar from "@/components/site/Navbar";
import ScrollScanner from "@/components/ScrollScanner";
import Hero from "@/components/site/Hero";
import HomeOverview from "@/components/site/HomeOverview";
import Difference from "@/components/site/Difference";
import WhyBedBugs from "@/components/site/WhyBedBugs";
import TreatmentExperience from "@/components/site/TreatmentExperience";
import Preparation from "@/components/site/Preparation";
import Philosophy from "@/components/site/Philosophy";
import TreatmentAreas from "@/components/site/TreatmentAreas";
import Discreet from "@/components/site/Discreet";
import PropertySections from "@/components/site/PropertySections";
import BedBugGuide from "@/components/site/BedBugGuide";
import Resources from "@/components/site/Resources";
import Pricing from "@/components/site/Pricing";
import Faq from "@/components/site/Faq";
import Reviews from "@/components/site/Reviews";
import Testimonials from "@/components/site/Testimonials";
import Booking from "@/components/site/Booking";
import Footer from "@/components/site/Footer";
import MobileCTA from "@/components/site/MobileCTA";
import { useSeo } from "@/lib/useSeo";
import { useJsonLd } from "@/lib/useJsonLd";

export default function Home() {
  useSeo({ path: "/" });
  useJsonLd("howto-treatment", {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How a Meridian bed bug treatment works",
    "description": "A clear, deliberate path from booking to follow-up — no inspection step, no back-and-forth.",
    "step": [
      { "@type": "HowToStep", "position": 1, "name": "Book", "text": "Tell us about the property — type, location, size and what you're seeing. We confirm an appointment window that works for you." },
      { "@type": "HowToStep", "position": 2, "name": "Prepare", "text": "You receive clear preparation instructions covering bedding, furniture, access to treatment areas and leaving the property during treatment." },
      { "@type": "HowToStep", "position": 3, "name": "Treat", "text": "Our technician arrives at the scheduled time and performs the bed bug treatment across the agreed areas of the property." },
      { "@type": "HowToStep", "position": 4, "name": "Aftercare", "text": "Follow post-treatment instructions — when to re-enter, how to handle treated surfaces, and what to do with bedding and belongings." },
      { "@type": "HowToStep", "position": 5, "name": "Follow-up", "text": "Where the program calls for it, we arrange the appropriate follow-up treatment to help break the bed bug life cycle." }
    ]
  });
  return (
    <div className="overflow-x-hidden pb-16 lg:pb-0">
      <ScrollScanner />
      <Navbar />
      <main id="main-content">
        <Hero />
        <HomeOverview />
        <Difference />
        <WhyBedBugs />
        <TreatmentExperience />
        <Preparation />
        <Philosophy />
        <TreatmentAreas />
        <Discreet />
        <PropertySections />
        <BedBugGuide />
        <Resources />
        <Pricing />
        <Faq />
        <Testimonials />
        <Reviews />
        <Booking />
      </main>
      <Footer />
      <MobileCTA />
    </div>
  );
}